import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerProjects = (state: AppState) =>
  state.taskTracker.projects.projects

export const selectTaskTrackerActiveProjectId = (state: AppState) =>
  state.taskTracker.projects.activeProjectId

export const selectTaskTrackerLoadingProjects = (state: AppState) =>
  state.taskTracker.projects.loadingProjects

export const selectTaskTrackerProjectsError = (state: AppState) =>
  state.taskTracker.projects.projectsError

export const selectTaskTrackerCreatingProject = (state: AppState) =>
  state.taskTracker.projects.creatingProject

export const selectTaskTrackerCreateProjectError = (state: AppState) =>
  state.taskTracker.projects.createProjectError

export const selectTaskTrackerReorderingProjects = (state: AppState) =>
  state.taskTracker.projects.reorderingProjects

export const selectTaskTrackerReorderingBoardsProjectId = (state: AppState) =>
  state.taskTracker.projects.reorderingBoardsProjectId

export const selectTaskTrackerActiveProject = (state: AppState) => {
  const activeProjectId = selectTaskTrackerActiveProjectId(state)
  if (activeProjectId == null) return null
  return (
    selectTaskTrackerProjects(state).find(
      (project) => project.id === activeProjectId,
    ) ?? null
  )
}

export const selectTaskTrackerProjectById = (
  state: AppState,
  projectId: number | null,
) => {
  if (projectId == null) return null
  return (
    selectTaskTrackerProjects(state).find((project) => project.id === projectId) ??
    null
  )
}
